






















































































































































































































import Vue from 'vue'

import Task from '@/components/workflow/Task.tsx'
import { CompleteTaskAction, FetchAction } from '@/store/workflow/actions'
import { SpecificActiveTask } from '@/queries/tasks.graphql'
import {
  TaskNodeFragment,
  SpecificActiveTaskQuery,
  SpecificActiveTaskQueryVariables,
  CaseNodeFragment,
} from '@/graphql-schema'

import { wrapVariables } from '@/utils'
import { VariablePayload } from '@/store/workflow/types'


export interface Data {
  locale: 'en' | 'de' | 'ar'
  tasks: SpecificActiveTaskQuery['tasks']
  taskForm: VariablePayload | null
}

export default Vue.extend({
  components: {
    CallPatient: () => import('./tasks/CallPatient.vue'),
    FillInIntermediateMeasurements: () => import('./tasks/FillInIntermediateMeasurements.vue'),
    ResetAppointment: () => import('./tasks/ResetAppointment.vue'),
    DecideAboutExclusion: () => import('./tasks/DecideAboutExclusion.vue'),
    InterviewerEntersRoom: () => import('./tasks/InterviewerEntersRoom.vue'),
    RecordInterview: () => import('./tasks/RecordInterview.vue'),
    TakeOverAppointment: () => import('./tasks/TakeOverAppointment.vue'),
    ArrangeFeedbackInterview: () => import('./tasks/ArrangeFeedbackInterview.vue'),
    RecordFeedbackInterview: () => import('./tasks/RecordFeedbackInterview.vue'),
    ReadLetter: () => import('./tasks/ReadLetter.vue'),
    WriteLetter: () => import('./tasks/WriteLetter.vue'),
    DropoutReminder: () => import('./tasks/DropoutReminder.vue'),
    WriteFinalReport: () => import('./tasks/WriteFinalReport.vue'),
    DecideOnDropout: () => import('./tasks/DecideOnDropout.vue'),
    AssignTherapist: () => import('./tasks/AssignTherapist.vue'),
    AssignCounselor: () => import('./tasks/AssignCounselor.vue'),
    ReadCounselingQuestions: () => import('./tasks/ReadCounselingQuestions.vue'),
    ContactClientForCounselingQuestions: () => import('./tasks/ContactClientForCounselingQuestions.vue'),
    ModifyCounselingQuestions: () => import('./tasks/ModifyCounselingQuestions.vue'),
    PhoneClientForSuicidalCheck: () => import('./tasks/PhoneClientForSuicidalCheck.vue'),
  },
  apollo: {
    tasks: {
      query: SpecificActiveTask,
      variables(): SpecificActiveTaskQueryVariables {
        return { taskId: this.$route.params.id }
      },
    },
  },
  computed: {
    relatedCase(): CaseNodeFragment | null | undefined {
      return this.selectedTask?.case
    },
    selectedTask(): TaskNodeFragment | undefined {
      if (this.tasks?.nodes.length) {
        return this.tasks.nodes[0]
      } else {
        return undefined
      }
    },
    isReadLetterTask(): boolean {
      const definitionKey = this.selectedTask?.taskDefinitionKey
      return definitionKey?.startsWith('read-p') || false
    },
    isWriteLetterTask(): boolean {
      const definitionKey = this.selectedTask?.taskDefinitionKey
      return definitionKey === 'write-final-letter' || definitionKey?.startsWith('write-t') || false
    },
    isTranslatable(): boolean {
      switch (this.selectedTask?.taskDefinitionKey) {
        case 'record-interview':
        case 'record-feedback-interview':
        case 'fill-in-intermediate-measurements':
          return true
        default:
          return false
      }
    },
  },
  data(): Data {
    return {
      locale: 'en',
      tasks: { nodes: [] },
      taskForm: {},
    }
  },
  methods: {
    async ok() {
      if (this.selectedTask) {
        const variables = wrapVariables(this.taskForm || {})
        if (
          this.selectedTask.taskDefinitionKey === 'record-interview' ||
          this.selectedTask.taskDefinitionKey === 'record-feedback-interview'
        ) {
          console.log('Completing task: ' + this.selectedTask.taskDefinitionKey)
          console.log(this.taskForm)
          if (
            'diagnosis' in this.taskForm &&
            this.taskForm.diagnosis === 'excluded' &&
            !window.confirm('Do you really want to exclude the customer?')
          ) {
            return
          } else if (!window.confirm('Do you really want to finish the interview report?')) {
            return
          }
        }
        await this.$store.dispatch({
          type: 'workflow/completeTask',
          task: this.selectedTask,
          variables: wrapVariables(this.taskForm || {}),
        })
        this.$router.push({ name: 'admin.tasks' })
      }
    },
    cancel(): void {
      this.$router.push({ name: 'admin.tasks' })
    },
  },
})
